module.exports = __webpack_public_path__ + "img/logo.774ad8d9.png";